import "../style/Features.css";
import "../style/Home.css";
import p1 from '../img/p1.png'
import p4 from '../img/p4.png'
import p8 from '../img/p8.png'


const featuresData = [
  {
    title: "Créez votre boutique",
    text:
      "Créez votre boutique en quelques minutes, ajoutez vos produits et personnalisez votre espace de vente sans aucune compétence technique.",
      img: p1,
  },
  {
    title: "Configurez votre paiement",
    text:
      "Activez les paiements en ligne facilement et commencez à encaisser immédiatement, avec une solution sécurisée et simple à gérer.",
      img: p4,
  },
  {
    title: "Vendez vos produits",
    text:
      "Partagez votre boutique, recevez des commandes et développez votre activité avec une solution pensée pour vendre rapidement.",
      img: p8,
  },
];

export default function Features() {
  return (
    <section className="feature-section">
      <div className="feature-grid">
        {featuresData.map(({ title, text, img }, i) => (
          <article key={i} className="feature-card" >
            {/* bloc “image” remplacé par une forme blanche */}
            <div className="feature-card__placeholder" style={{backgroundImage: `url(${img})`}}>
            <div className='banner-filter filter-feature'></div>
            </div>
            
            <h3 className="feature-card__title">{title}</h3>
            <p className="feature-card__desc">{text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

